import { useEffect, useState } from "react";
import { Play, Pause, RotateCcw, Timer } from "lucide-react";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";
import { loadTimer, saveTimer, elapsedOf, fmtHMS } from "@/lib/jobTimer";

export function JobTimer({ job }) {
  const [state, setState] = useState(() => loadTimer(job.id, job.time_ms || 0));
  const [, setTick] = useState(0);

  useEffect(() => { saveTimer(job.id, state); }, [state, job.id]);

  useEffect(() => {
    if (!state.running) return;
    const t = setInterval(() => setTick((x) => x + 1), 500);
    return () => clearInterval(t);
  }, [state.running]);

  const elapsed = elapsedOf(state);
  const persist = (ms) => api.post(`/jobs/${job.id}/time`, { ms: Math.round(ms) }).catch(() => {});

  const start = () => setState({ ...state, running: true, startedAt: Date.now() });
  const pause = () => { const ms = elapsed; setState({ running: false, accumulated: ms, startedAt: null }); persist(ms); };
  const reset = () => { setState({ running: false, accumulated: 0, startedAt: null }); persist(0); };

  return (
    <div className="flex items-center gap-1 rounded-md border border-border bg-muted/40 px-2 py-1" data-testid={`job-timer-${job.id}`}>
      <Timer className={`h-3.5 w-3.5 ${state.running ? "text-primary" : "text-muted-foreground"}`} />
      <span className="font-mono font-semibold tabular-nums text-xs w-[60px]" data-testid={`job-timer-time-${job.id}`}>{fmtHMS(elapsed)}</span>
      {!state.running ? (
        <Button size="icon" variant="ghost" className="h-6 w-6" onClick={start} data-testid={`job-timer-start-${job.id}`} title="Iniciar">
          <Play className="h-3.5 w-3.5 text-green-600" />
        </Button>
      ) : (
        <Button size="icon" variant="ghost" className="h-6 w-6" onClick={pause} data-testid={`job-timer-pause-${job.id}`} title="Pausar">
          <Pause className="h-3.5 w-3.5 text-orange-500" />
        </Button>
      )}
      <Button size="icon" variant="ghost" className="h-6 w-6" onClick={reset} data-testid={`job-timer-reset-${job.id}`} title="Reiniciar">
        <RotateCcw className="h-3.5 w-3.5 text-muted-foreground" />
      </Button>
    </div>
  );
}
